import React from 'react';

export interface PasswordValidation {
  length: boolean;
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  special: boolean;
}

interface PasswordValidationDisplayProps {
  password: string;
  validation: PasswordValidation;
  show?: boolean;
  className?: string;
}

const PasswordValidationDisplay: React.FC<PasswordValidationDisplayProps> = ({ validation, className = '' }) => {
  const validationRules = [
    {
      key: 'length',
      label: 'At least 8 characters long',
      valid: validation.length,
    },
    {
      key: 'uppercase',
      label: 'Contains uppercase letter (A-Z)',
      valid: validation.uppercase,
    },
    {
      key: 'lowercase',
      label: 'Contains lowercase letter (a-z)',
      valid: validation.lowercase,
    },
    { key: 'number', label: 'Contains number (0-9)', valid: validation.number },
    {
      key: 'special',
      label: 'Contains special character (!@#$%^&*...)',
      valid: validation.special,
    },
  ];

  return (
    <div className={`border rounded-md p-3 ${className}`} style={{ backgroundColor: 'var(--surface-overlay)', borderColor: 'var(--border-subtle)' }}>
      <p className="text-sm font-medium mb-2" style={{ color: 'var(--text-secondary)' }}>
        Password requirements:
      </p>
      <div className="space-y-1">
        {validationRules.map((rule) => (
          <div
            key={rule.key}
            className={`flex items-center text-sm ${rule.valid ? 'text-green-500' : ''}`}
            style={rule.valid ? {} : { color: 'var(--text-muted)' }}
          >
            <span className="mr-2">{rule.valid ? '✓' : '○'}</span>
            {rule.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordValidationDisplay;
